/* eslint-disable react/no-array-index-key */
import React from 'react';
import moment from 'moment';
import { Row, Col, Card, CardBody, Table } from 'reactstrap';

import { StatusVenda } from '~/components/Status';
import { Cartoes } from '~/components/Cartoes';
import { LoaderMini } from '~/components/Loaders';
import { Text } from '~/components/Text';

import { color } from '~/assets/styles/colors';
import { symbolPriceFormatter } from '~/helpers/price';
import { TrStyled } from '../styles';

export function TransacoesSimples({ transacoes }) {
	function dateSort(a, b) {
		return (
			moment(a.payment_date).format('YYYY-MM-DD') >
			moment(b.payment_date).format('YYYY-MM-DD')
		);
	}

	function retornaModalidade(cell, row) {
		if (row.parcels > 1) {
			return `Parcelado em ${row.parcels}x`;
		}
		if (cell === 'crédito à vista') {
			return `Crédito à vista`;
		}
		if (cell === 'débito') {
			return `Débito`;
		}
		return cell;
	}

	return (
		<Table id="test-table-xls-button" responsive className="notranslate">
			<thead>
				<TrStyled>
					<th>Id</th>
					<th>Data</th>
					<th>Valor</th>
					<th>Bandeira</th>
					<th>Modalidade</th>
					<th>Status</th>
				</TrStyled>
			</thead>
			<tbody>
				{transacoes &&
					transacoes.dados.data.sort(dateSort).map((item, index) => (
						<tr key={`${item.id}-${index}`}>
							<td>{item.id}</td>
							<td>
								{moment.utc(item.payment_date).format('DD/MM/YYYY')}
							</td>
							<td>{symbolPriceFormatter(item.value)}</td>
							<td>
								<Cartoes cartao={item.brand} />
							</td>
							<td>{retornaModalidade(item.product, item)}</td>
							<td>
								<StatusVenda status={item.status} />
							</td>
						</tr>
					))}
			</tbody>
		</Table>
	);
}

export function CardSimples({ loadingTransactions, transacoes }) {
	const dadosSimples = [
		{
			nome: 'Total de vendas',
			nome_index: 'total_geral',
			color: 'white',
			bg_color: color.softBlack,
		},
		{
			nome: 'Débito',
			nome_index: 'total_debito',
			color: 'gray',
			bg_color: color.yellow,
		},
		{
			nome: 'Crédito à vista',
			nome_index: 'total_credito',
			color: 'gray',
			bg_color: color.yellow,
		},
		{
			nome: 'Parcelado 2 a 6 vezes',
			nome_index: 'total_parcelo2a6',
			color: 'gray',
			bg_color: color.yellow,
		},
		{
			nome: 'Parcelado 7 a 12 vezes',
			nome_index: 'total_parcelo7a12',
			color: 'gray',
			bg_color: color.yellow,
		},
		{
			nome: 'Parcelado 13 a 18 vezes',
			nome_index: 'total_parcelo13a18',
			color: 'gray',
			bg_color: color.yellow,
		},
		{
			nome: 'Parcelado 19 a 24 vezes',
			nome_index: 'total_parcelo19a24',
			color: 'gray',
			bg_color: color.yellow,
		},
	];

	return (
		<Row className="mt-5">
			{dadosSimples.map((item) => (
				<Col lg="2" md="4">
					<Text>{item.nome}</Text>
					<Card
						style={{
							backgroundColor: item.bg_color,
							borderRadius: '0px 10px 10px 10px',
						}}>
						<CardBody className="py-4 px-2">
							{loadingTransactions ? (
								<div className="d-flex justify-content-center">
									<LoaderMini />
								</div>
							) : (
								<Text color={item.color} size="big" center>
									{symbolPriceFormatter(
										transacoes.dados[item.nome_index]
									)}
								</Text>
							)}
						</CardBody>
					</Card>
				</Col>
			))}
		</Row>
	);
}
